<template>
    <div class="login-container">
        <div class="login-content">
          <div class="hdp-uf hdp-uf-vc hdp-uf-dc">
            <div class="hdp-uf psc-color-white login-title" :class="$t('m.LapStyle')">
              {{$t('m.Lap')}}
            </div>
            <div class="form">
                <div class="logo-content">
                    <img src="../../assets/images/deloitte-logo.png" alt="logo">
                </div>
                <div class="body-content">
                    <div class="input-style">
                         <el-input class="login-input" :placeholder="$t('m.inputAccount')" v-model="loginForm.account" @keyup.enter.native="login()">
                            <template slot="prepend"><i class="icon-user"></i></template>
                        </el-input>
                    </div>
                    <div class="input-style">
                        <el-input class="login-input" :placeholder="$t('m.inputPwd')" type="password" v-model="loginForm.password" @keyup.enter.native="login()">
                            <template slot="prepend"><i class="icon-lock"></i></template>
                        </el-input>
                    </div>

                    <div class="input-style">

                    </div>
                    <div class="btn-style">
                        <el-button id="TencentCaptcha"
                                   data-appid="2032209322"
                                   data-cbfn="callback" class="login-btn" type="primary"
                        >{{$t('m.login')}}</el-button>
                        <el-button id="login_lap" v-show="false" class="login-btn" type="primary" @click="login()">{{$t('m.login')}}</el-button>
                    </div>
                </div>
                <div class="footer-content">
                    <!-- <el-button type="text" @click="clickChange()">{{$t('m.changePwd')}}</el-button> -->
                    <el-button type="text" @click="clickForget()">{{$t('m.forgetPwd')}}</el-button>
                    <lap-change-lang></lap-change-lang>
                </div>
            </div>
          </div>
        </div>
        <el-dialog
            :title="$t('m.forgetPwd')"
            :visible.sync="forgetDialogVisible"
            v-if="forgetDialogVisible"
            width="600px">
            <div class="dialog-content">
                <el-form ref="forgetForm" :model="forgetForm" :rules="forgetRules" label-width="100%">
<!--                    <el-form-item :label="$t('m.mobile')" prop="phone" style="width: 460px" key="1">-->
<!--                        <el-input v-model="forgetForm.phone"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item :label="$t('m.newPwd')" prop="password" style="width: 460px"  key="2">-->
<!--                        <el-input type="password" auto-complete="new-password" v-model="forgetForm.password"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item :label="$t('m.confirmPwd')" prop="passwordRel" style="width: 460px"  key="3">-->
<!--                        <el-input type="password" v-model="forgetForm.passwordRel"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item :label="$t('m.code')" prop="vaildCode" style="width: 460px">-->
<!--                        <el-row>-->
<!--                            <el-col :span="14">-->
<!--                                <el-input v-model="forgetForm.vaildCode"></el-input>-->
<!--                            </el-col>-->
<!--                            <el-col :span="8" :offset="2">-->
<!--                                <button class="code-btn" :disabled="btnDisabled" @click="sendCode()">{{codeText}}</button>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </el-form-item>-->
                    <el-form-item :label="$t('m.forgetPwdHelp')" >

                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="forgetDialogVisible = false">{{$t("m.cancel")}}</el-button>
<!--                <el-button type="primary" @click="forgetPwd()">{{$t("m.sure")}}</el-button>-->
                <el-button type="primary" @click="forgetDialogVisible = false">{{$t("m.sure")}}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="$t('m.changePwd')"
            :visible.sync="changeDialogVisible"
            v-if="changeDialogVisible"
            width="600px">
            <div class="dialog-content">
                <el-form :model="changeForm" status-icon :rules="changeRules" ref="changeForm" label-width="140px">
                    <el-form-item :label="$t('m.oldPwd')" prop="oldPassword" style="width: 460px">
                        <el-input type="password" v-model="changeForm.oldPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.newPwd')" prop="newPassword" style="width: 460px">
                        <el-input type="password" v-model="changeForm.newPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.confirmPwd')" prop="newPasswordRe" style="width: 460px">
                        <el-input type="password" v-model="changeForm.newPasswordRe" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changeDialogVisible = false">{{$t("m.cancel")}}</el-button>
                <el-button type="primary" @click="changePwd()">{{$t("m.sure")}}</el-button>

            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'

let Base64 = require('js-base64').Base64

window.callback = function(res){
    // console.log(res)
    // res（用户主动关闭验证码）= {ret: 2, ticket: null}
    // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    if(res.ret === 0){
        // alert(res.ticket)   // 票据
        document.getElementById("login_lap").click();

    }
}
export default {
    name: 'Login',
    data() {
        let validatePass1 = (rule, value, callback) => {
            if (this.changeForm.newPassword !== '') {
                this.$refs.changeForm.validateField('newPassword');
                callback();
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (this.changeForm.oldPassword && value == this.changeForm.oldPassword) {
                callback(new Error(this.$t('m.pwdMessage1')));
            } else if (this.changeForm.newPasswordRe !== '') {
                this.$refs.changeForm.validateField('newPasswordRe');
                callback();
            } else {
                callback();
            }
        };
        let validatePass3 = (rule, value, callback) => {
            if (this.changeForm.newPassword && value !== this.changeForm.newPassword) {
                callback(new Error(this.$t('m.pwdMessage2')));
            } else {
                callback();
            }
        };
        let validatePass4 = (rule, value, callback) => {
           if (this.forgetForm.passwordRel !== '') {
                this.$refs.forgetForm.validateField('passwordRel');
                callback();
            } else {
                callback();
            }
        };
        let validatePass5 = (rule, value, callback) => {
            if (this.forgetForm.password && value !== this.forgetForm.password) {
                callback(new Error(this.$t('m.pwdMessage2')));
            } else {
                callback();
            }
        };
        let passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8,15}$/;

        return {
            loginForm: {
                account: localStorage.getItem('account'),
                password: '',
            },
            loginFormEncode: {
                account: '',
                password: '',
            },
            forgetDialogVisible: false,
            forgetForm: {
                phone: '',
                password: '',
                passwordRel: '',
                vaildCode: ''
            },
            forgetFormEncode: {
                phone: '',
                password: '',
                passwordRel: '',
                vaildCode: ''
            },
            forgetRules: {
                phone: [
                    { required: true, message: this.$t('m.inputMobie'), trigger: 'blur' },
                    { pattern: /^\d{1,14}$/, message: this.$t('m.inputMobie'), trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('m.inputNewPwd'), trigger: 'blur' },
                    { pattern: passwordReg, message: this.$t('m.inputPwdRule'), trigger: 'blur' },
                    { validator: validatePass4, trigger: 'blur' }
                ],
                passwordRel: [
                    { required: true, message: this.$t('m.inputConfirmPwd'), trigger: 'blur' },
                    { pattern: passwordReg, message: this.$t('m.inputPwdRule'), trigger: 'blur' },
                    { validator: validatePass5, trigger: 'blur' }
                ],
                vaildCode: [
                    { required: true, message: this.$t('m.inputCode'), trigger: 'blur' },
                ]
            },
            codeText: this.$t('m.sendCode'),
            btnDisabled: false,
            changeDialogVisible: false,
            changeForm: {
                oldPassword: '',
                newPassword: '',
                newPasswordRe: ''
            },
            changeFormEncode: {
                oldPassword: '',
                newPassword: '',
                newPasswordRe: ''
            },
            changeRules: {
                oldPassword: [{
                        required: true,
                        message: this.$t('m.inputOldPwd'),
                        trigger: 'blur'
                    },
                    {
                        pattern: passwordReg,
                        message: this.$t('m.inputPwdRule'),
                        trigger: 'blur'
                    },
                    {
                        validator: validatePass1,
                        trigger: 'blur'
                    }
                ],
                newPassword: [{
                        required: true,
                        message: this.$t('m.inputNewPwd'),
                        trigger: 'blur'
                    },
                    {
                        pattern: passwordReg,
                        message: this.$t('m.inputPwdRule'),
                        trigger: 'blur'
                    },
                    {
                        validator: validatePass2,
                        trigger: 'blur'
                    }
                ],
                newPasswordRe: [{
                        required: true,
                        message: this.$t('m.inputConfirmPwd'),
                        trigger: 'blur'
                    },
                    {
                        pattern: passwordReg,
                        message: this.$t('m.inputPwdRule'),
                        trigger: 'blur'
                    },
                    {
                        validator: validatePass3,
                        trigger: 'blur'
                    }
                ]
            },
        }
    },
    methods: {
        clickForget() {
            this.forgetDialogVisible = true
            this.forgetForm = {
                phone: '',
                password: '',
                passwordRel: '',
                vaildCode: ''
            }
        },
        clickChange() {
            this.changeDialogVisible = true
            this.changeForm = {
                oldPassword: '',
                newPassword: '',
                newPasswordRe: ''
            }
        },
        login() {
            if(!this.loginForm.account&&!this.loginForm.password) {
                this.$message.error(this.$t('m.inputAccountAndPwd'))//请输入用户名和密码
                return
            } else if (!this.loginForm.account||!this.loginForm.password) {
                this.$message.error(this.$t('m.inputAccountOrPwd'))//请输入用户名或密码
                return
            }
            this.loginFormEncode.account = this.loginForm.account
            this.loginFormEncode.password = Base64.encode(this.loginForm.password)
            this.$commonFunc.commonRequest( 'post', '/system/user/login', 'login', this.loginFormEncode)
            .then(res=>{
                let resObj = res.obj
                //this.$store.dispatch('userInfo/getServerData', res.obj)
                localStorage.setItem('account', this.loginForm.account)
                // //设置axios公共请求头
                //axios.defaults.headers.common['lap-cookie-token'] = res.obj.token
                localStorage.setItem('token', res.obj.token)
                // this.$router.push("index")
                this.$commonFunc.commonRequest( 'get', '/system/user/vaildUserPassword', 'vaildUserPassword', {userId: res.obj.userId})
                .then(res=>{
                    if(res.obj === 0) {
                     //   this.$message.error('密码已到期，请修改密码')
                        this.$message.error(this.$t('m.passExpire3'))
                        setTimeout(()=>{
                            this.clickChange()
                        }, 2000)
                    } else if(res.obj === -1) {
                        this.$store.dispatch('userInfo/getServerData', resObj)
                        this.$router.push("index")
                    } else {
                 //       this.$message.info('密码还有'+ res.obj + '天到期，请尽快修改密码')

                        this.$message.info(this.$t('m.passExpire1')+ res.obj + this.$t('m.passExpire2'))
                        this.$store.dispatch('userInfo/getServerData', resObj)
                        this.$router.push("index")
                    }
                })
                .catch(res=>{
                    this.$message.error(res.message)
                })
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        forgetPwd() {
            this.$refs["forgetForm"].validate((valid) => {

                if (valid) {
                    this.forgetFormEncode.phone = this.forgetForm.phone
                    this.forgetFormEncode.vaildCode = this.forgetForm.vaildCode
                    this.forgetFormEncode.password = Base64.encode(this.forgetForm.password)
                    this.forgetFormEncode.passwordRel = Base64.encode(this.forgetForm.passwordRel)
                    this.$commonFunc.commonRequest('post', '/system/user/forgetPassword', 'forgetPwd', this.forgetFormEncode)
                    .then(res=>{
                        this.$message({
                          message: this.$t('m.resetPwdSuc'),
                          type: 'success'
                        });
                        this.forgetDialogVisible = false
                    })
                    .catch(res=>{
                        this.$message.error(res.message)
                    })
                } else {
                    return false;
                }
            });
        },
        sendCode() {
            if(!this.forgetForm.phone) {
                this.$message.error(this.$t('m.inputMobie'))
                return
            }
            this.$commonFunc.commonRequest( 'get', '/system/user/sendvaildCode', 'sendCode', { phone: this.forgetForm.phone, action: 'sms_forget' })
            .then(res=>{
                this.btnDisabled = true
                this.codeText = 60
                this.timer = setInterval(() => {
                    if (this.codeText > 0 ) {
                        this.codeText--;
                    } else if (this.codeText == 0) {
                        this.codeText = this.$t('m.sendCode')
                        this.btnDisabled = false
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }).catch(res=>{
                this.$message.error(res.message)
            })
        },
        changePwd () {
            this.$refs['changeForm'].validate((valid) => {
                if (valid) {
                    this.changeFormEncode.oldPassword = Base64.encode(this.changeForm.oldPassword)
                    this.changeFormEncode.newPassword = Base64.encode(this.changeForm.newPassword)
                    this.changeFormEncode.newPasswordRe = Base64.encode(this.changeForm.newPasswordRe)
                    this.$commonFunc.commonRequest('post', '/system/user/updatePassword', 'changePwd', this.changeFormEncode)
                        .then(res => {
                            this.$message({
                                message: this.$t('m.changePwdSuc'),
                                type: 'success'
                            });
                            this.changeForm = {
                                oldPassword: '',
                                newPassword: '',
                                newPasswordRe: ''
                            }
                            this.$refs['changeForm'].clearValidate()
                            this.changeDialogVisible = false
                        })
                        .catch(res => {
                            this.$message.error(res.message)
                        })
                } else {
                    return false
                }
            })
        }
    },
    mounted() {
        //设置系统语言
        var lang = localStorage.getItem('defaultLang') || navigator.language || navigator.userLanguage;//常规浏览器语言和IE浏览器
        lang = lang.substr(0, 2);//截取lang前2位字符
        localStorage.setItem('defaultLang', lang)
    }
}
</script>
<style scoped lang="scss">
/deep/ .el-input-group__prepend {
    padding: 0 12px !important;
    background-color: #E0E0E0 !important;
    color: #BBBCBC !important;
}
.login-container {
    height: 100%;
    width:100%;
    background: url("../../assets/images/bg.png") no-repeat;
    background-size: cover;
    overflow: hidden;
    .login-content {
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-left: 12%;
        align-items: flex-start;
        padding-top: 12%;
        height: 100%;
        .login-title{
          font-weight:bolder;
        }
        .form {
            width:350px;
            background: #fff;
            border-radius: 5px;
            margin-top: 30px;
            padding: 24px 24px 24px;
            .logo-content {
                margin-bottom:40px;
                img{
                  height:30px;
                  width:auto;
                }
            }
            .body-content {
                .input-style {
                    margin-bottom: 16px;
                }
                .btn-style {
                    width: 100%;
                    margin-top: 34px;
                    .login-btn {
                        width: 100%;
                        word-spacing:30px;
                        font-size: 16px;
                    }
                }
                .login-input{
                  font-size: 16px;
                }
            }
            .footer-content {
                display: flex;
                justify-content: space-between;
            }
        }
    }
}
.code-btn{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-around;
    line-height: 40px;
    background: #ecf5ff;
    color: #00A3E0;
    border: 1px solid #BBE6EB;
    font-size: 14px;
    outline: none;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/Login.vue